import { HallOfFameCard } from "@components/cards/HallOfFameCard"
import { DirectoryHeader } from "@components/layout/DirectoryHeader"
import { ResultList } from "@components/layout/ResultList"
import { StaggerTransitionRoot } from "@components/motion/Transition"
import { defineView } from "eddev/views"

export default defineView("archive-hall-of-fame", (props) => {
  return (
    <StaggerTransitionRoot>
      <DirectoryHeader heading="Hall of Fame" displayMode="card" />
      <ResultList mode="card" items={props.hallOfFameArticles?.nodes!} component={HallOfFameCard} dynamicSizing={false} keyField="uri" mobileMode="row" />
    </StaggerTransitionRoot>
  )
})
